"use client";

import React from "react";
import { Title } from "@motorata/base-ui.components.atoms.typography";
import TextHTML from "@motorata/base-ui.components.atoms.text-html";
import styled from "styled-components";
import { blockPadding, blockStyles, Box } from "@/components/common/_atoms";

export default function LegalTemplate({ title, content }: {
  title: string
  content: string
}) {
  return (
    <>
      <Header className="background">
        <Title type="primary" label="Informacje" margin="0">
          {title}
        </Title>
      </Header>
      <Content>
        <TextHTML type="secondary" content={content} />
      </Content>
    </>
  )
}


const Header = styled(Box)`
  ${blockStyles};
  ${blockPadding};
  padding-top: 0;
  max-width: 1000px;

  &:before {
    height: 100vh !important;
    bottom: 0 !important;
    top: auto !important;
  }
`

const Content = styled(Box)`
  ${blockStyles};
  max-width: 1000px;
`
